import { initializeApp } from "firebase/app";
import { getAuth } from "firebase/auth";
import { getFirestore } from "firebase/firestore";
import { getStorage } from "firebase/storage";

// Your precise Firebase configuration
const firebaseConfig = {
  apiKey: "AIzaSyBiJACb1vNaH01GjHwVc9sA6BVab8iFA0A",
  authDomain: "affiearn-ad591.firebaseapp.com",
  databaseURL: "https://affiearn-ad591-default-rtdb.firebaseio.com",
  projectId: "affiearn-ad591",
  storageBucket: "affiearn-ad591.firebasestorage.app",
  messagingSenderId: "108555316077",
  appId: "1:108555316077:web:8093633724e6cf7d778864",
  measurementId: "G-DLKELVP7F3"
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);

// Initialize and Export Auth, DB, and Storage
export const auth = getAuth(app);
export const db = getFirestore(app);
export const storage = getStorage(app); 

